export default "__VITE_ASSET__47_8BZaR__"